import * as Sentry from "@sentry/browser";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import { makeId } from "sweet-global";

// Initialize Firebase
const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "sweet-space.firebaseapp.com",
  databaseURL: "https://sweet-space.firebaseio.com",
  projectId: "sweet-space",
  storageBucket: "sweet-space.appspot.com",
  messagingSenderId: "1085297850594",
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};
const fire = firebase.initializeApp(config);

const storage = fire.storage();

export const UploadFile = async (bucket: string, file: File, id?: string) => {
  try {
    const refId = !!id ? id : makeId();
    const ref = `/${bucket}/${refId}`;

    await storage.ref(ref).put(file);
    const url = await storage.ref(ref).getDownloadURL();

    return url;
  } catch (error) {
    console.log(error);
    Sentry.captureException(error);

    return null;
  }
};

export default fire;
